module.exports = __webpack_public_path__ + "img/luxura_v6.min.07ad65d0.svg";